import React from "react";
import { HiExclamationTriangle } from "react-icons/hi2";
import { XMarkIcon } from "@heroicons/react/24/solid";

interface DeleteConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  logType: string;
  isDeleting: boolean;
}

const DeleteConfirmDialog: React.FC<DeleteConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  logType,
  isDeleting,
}) => {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center p-4 bg-black bg-opacity-50 backdrop-blur"
      style={{ transform: "translateZ(0)" }}
    >
      <div className="bg-base-100 rounded-lg shadow-xl max-w-sm w-full">
        {/* Header */}
        <div className="flex items-center gap-3 p-6 pb-2">
          <XMarkIcon className="w-6 h-6 text-red-500" />
          <h2 className="text-2xl font-sans font-semibold text-base-content">
            Confirm Deletion?
          </h2>
        </div>

        {/* Content */}
        <div className="px-6 pb-2">
          <p className="text-sm text-base-content/80">
            Are you sure you want to delete this{" "}
            <strong>{logType.toLowerCase()}</strong> log? This action cannot be
            undone.
          </p>
        </div>

        {/* Actions */}
        <div className="flex justify-between gap-3 p-6 pt-4">
          <button
            onClick={onClose}
            className=" bg-base-200 px-3 py-2 rounded-md font-medium"
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className=" text-base-content bg-red-500/15 text-red-600 px-3 py-2 rounded-md font-medium"
            disabled={isDeleting}
          >
            {isDeleting ? (
              <>
                <span className="loading loading-spinner loading-sm mr-2"></span>
                Deleting...
              </>
            ) : (
              "Delete"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmDialog;
